<template>
    <v-card variant="elevated" :title="t('suppliers')" class="mx-auto dash-card" width="210">
        <template v-slot:append>
            <svg-icon type="mdi" :path="mdiAccountPlus" class="mr-2"></svg-icon>
        </template>
        <v-card-text>    
            <p>{{ userMessage }}</p>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAccountPlus } from '@mdi/js';
import { useI18n } from 'vue-i18n';

const store = useStore();
const suppliersStatistics = ref({ totalSuppliers: 0 });
const { t } = useI18n(); // i18n instance for translations

onMounted(async () => {
    await store.dispatch('dashboard/fetchDashboardStatistics'); // Fetch statistics on component mount
    suppliersStatistics.value = store.state.dashboard.dashboardStatistics; // Bind the statistics
});

// Here's the computed property for the user message
const userMessage = computed(() => {
    const currentUserRole = localStorage.getItem('role'); // Get the role from local storage
    const { totalSuppliers } = suppliersStatistics.value;

    // Conditional message based on role and user count
    if (currentUserRole === 'super') {
        if (totalSuppliers === 1) {
            return `${t('one')} ${t('supplier')}`;
        } else {
            return `${totalSuppliers} ${t('suppliers')}`;
        }
    } else {
        if (totalSuppliers === 1) {
            return `${t('one')} ${t('supplier')}.`;
        } else {
            return `${totalSuppliers} ${t('suppliers')}.`;
        }
    }
});
</script>

<style>
a {
    text-decoration: none; /* Ensure no underline on the text */
    display: inline-block; /* Block elements for card */
    width: 100%; /* Full width for the card */
}

.dash-card {
    background-color: #fafafa;
    border-radius: 8px;
    padding: 3px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    text-decoration: none;
    transition: transform 0.2s;
    cursor: pointer;
}
</style>